<template>
  <div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">运单查询</div>
      </div>
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">运单号</div>

              <input
                v-model="screen.ordernumber"
                type="text"
                placeholder="请输入运单号"
                class="table_item_input"
              />
            </div>
           
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国内单号</div>

              <input
                v-model="screen.domesticnumber"
                type="text"
                placeholder="请输入国内单号"
                class="table_item_input"
              />
            </div>
          
          </div>
        

          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" @click="search" round>搜索</el-button>
              <el-button @click="reset" round>重置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">运单列表</div>
      </div>
      <div class="table_box">
        <el-table
           v-loading='tableLoading'
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          :data="orderData.content"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" prop="datecreated" label="创建日期">
          </el-table-column>
          <el-table-column align="center" prop="ordernumber" label="单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="domesticnumber"
            label="国内单号"
          >
          </el-table-column>
          <el-table-column align="center" prop="recipientname" label="收件人">
          </el-table-column>
          <el-table-column align="center" prop="weightkg" label="收费重量">
          </el-table-column>
          <el-table-column align="center" prop="shippingcost" label="总运费">
          </el-table-column>
          <el-table-column align="center" prop="state" label="最新状态">
             <template slot-scope="scope">
              <div>未入库</div>
              
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="转运状态">
            <template slot-scope="scope">
              <el-button type="text">待申请</el-button>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                class="round_btn"
                @click="showDialog(scope.row.id, scope.row.isfromchina)"
                type="primary"
                size="small "
                round
                >申请退运</el-button
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="详情" width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="details(scope.row.id)"
                >查看详情</el-button
              >
               <el-button @click="logistics(scope.row)" type="text"
                >物流详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging_box">
        <el-pagination
          @current-change="pageChange"
          background
          layout="prev, pager, next"
          :total="orderData.totalElements"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :center="true"
      title="请填写退运原因和地址"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleCloses"
    >
      <div class="fill_in_list">
        <div class="fill_in_list_l">
          <div class="fill_in_title">退运地址</div>
        </div>
        <el-input
          class="textarea"
          type="textarea"
          :rows="9"
          placeholder="请填写退运原因"
          v-model="textarea"
        >
        </el-input>
        <div class="fill_in_list_l">
          <div class="fill_in_title">退运地址</div>
        </div>
        <div class="input_select">
          {{ selectAddress.province }}{{ selectAddress.city
          }}{{ selectAddress.district }}{{ selectAddress.detailArea }}
          {{ selectAddress.consignee }} {{ selectAddress.mobile }}
        </div>
      </div>
      <el-button type="text" class="text_btn" @click="selectAddressBtn"
        >选择其他地址></el-button
      >
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button
          :loading="loading"
          type="primary"
          class="confirm_btn"
          @click="submitReturn"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      center
      title="选择地址"
      :visible.sync="dialogVisibleAddress"
      width="40%"
      :before-close="handleClose"
    >
      <div class="flex_box">
        <el-button type="primary" @click="addAddress" plain
          >+新增收货人信息</el-button
        >
      </div>
      <div class="address_model">
        <el-radio
          width="100%"
          size="medium"
          v-model="selectAddresss"
          :label="item"
          v-for="(item, index) in addressList.content"
          :key="index"
        >
          <div class="address_item">
            <div class="user_info_title">
              <div class="user_info">
                <div class="user_name">{{ item.consignee }}</div>
                <el-button
                  v-if="item.isDefault == 1"
                  type="primary"
                  size="mini"
                  round
                  >默认地址</el-button
                >
              </div>
            </div>
            <div class="user_info">
              <div class="title_text_gh">国内收货人：</div>
              <div class="title_details">{{ item.consignee }}</div>
            </div>
            <div class="user_info">
              <div class="title_text_gh">国内电话：</div>
              <div class="title_details">{{ item.mobile }}</div>
            </div>
            <div class="user_info_title">
              <div class="user_info" style="margin: 0">
                <div class="title_text_gh">国内地址：</div>
                <div class="title_details">
                  {{ item.province }}{{ item.city }}{{ item.district
                  }}{{ item.detailArea }}
                </div>
              </div>
            </div>
          </div>
        </el-radio>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAddress = false">取 消</el-button>
        <el-button type="primary" @click="affirmAddress">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
      tableLoading:'',
      selectAddresss: "",
      dialogVisibleAddress: false,
      loading: false,
      textarea: "",
      screenText: "",
      orderData: [],
      screen: {
        page: 1,
        size: 10,
        ordernumber: "",
        domesticnumber: "",
        state: 1,
      },
      dialogVisible: false,
      isDefault: 1,
      isfromchina: "",
      orderId: "",
      selectAddress: "",
      addressList: [],
      sendAddressId: "",
      circuitData: [],
    };
  },
  created() {
    // this.orderList();
  },
  methods: {
      // 物流详情
    logistics(item) {
      localStorage.setItem("order", JSON.stringify(item));
      this.$router.push({
        path:
          "/logistics/logistics?code=" +
          item.domesticcarrier +
          "&num=" +
          item.domesticnumber,
      });
    },
    //筛查
    search() {
      this.orderList();
    },
    reset() {
      this.screen = {
           page: 1,
        size: 10,
        ordernumber: "",
        domesticnumber: "",
        state: 1,
      };
      this.orderList();
    },
    //点击新增地址
    addAddress() {
        this.$router.push({ path: "/userInfo/addAddress?type="+this.isfromchina+'&status=0' });
      // this.$router.push({ path: "/userInfo/addAddress" });
    },
    //确认选择的地址
    affirmAddress() {
      this.selectAddress = this.selectAddresss;
      this.dialogVisibleAddress = false;
    },
    //关闭地址弹框
    handleClose() {
      this.dialogVisibleAddress = false;
    },
    handleCloses() {
      this.dialogVisible = false;
    },
    //点击选择其他地址
    selectAddressBtn() {
      this.dialogVisibleAddress = true;
      this.isDefault = "";
      this.addressData();
    },
    //分页
    pageChange(e) {
      this.screen.page = e;
      this.orderList();
    },
    //查看详情
    details(e) {
      this.$router.push({
        path: "/parcel/parcelDetail?id=" + e + "&name=退运",
      });
    },
    //筛选
    clickScreen() {},
    //点击申请退运按钮
    showDialog(id, isfromchina) {
      this.orderId = id;
      this.dialogVisible = true;
      this.isfromchina = isfromchina;
      this.addressData();
    },
    //确认退运
    submitReturn() {
      // var id = [];
      // id.push(this.orderId);
      var data = {
        businessId: this.orderId,
        applyContent: this.textarea,
        addressId: this.sendAddressId,
        type: 3,
      };
      this.loading = true;
      crudDept.applyReturn(data).then((res) => {
        this.dialogVisible = false;
        this.loading = false;
        this.$message({
          message: "操作成功，请等待审核",
          type: "success",
        });
        this.orderList();
      }).catch((err) => {
          this.loading = false;
        });
    },
    //订单列表
    orderList() {
      this.tableLoading=true;
      crudDept.orderList(this.screen).then((res) => {
        this.orderData = res;
        this.tableLoading=false;
      }).catch((res)=>{
         this.tableLoading=false;
      })
    },
    // 线路
    circuit() {
      var data = {
        page: 1,
        size: 100,
      };
      crudDept.circuit(data).then((res) => {
        this.circuitData = res.content;
        res.content.map((item) => {
          item.value = item.id;
          item.label = item.name;
        });
        this.circuitData = res.content;
      });
    },
    //收货地址
    addressData() {
      var data = {
        page: 1,
        size: 50,
        isDefault: this.isDefault,
        addresstype: this.isfromchina,
      };
      crudDept.address(data).then((res) => {
        if (this.isDefault == 1) {
          if (res.content.length > 0) {
            this.selectAddress = res.content[0];
            this.sendAddressId = res.content[0].id;
          }
        }
        this.addressList = res;
      });
    },
  },
};
</script>
<style scoped>
.flex_box {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
}
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
.textarea {
  margin: 7px 0 23px;
}
.text_btn {
  margin: 0 auto !important;
  display: block;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}

.table_box {
  margin-top: 32px;
}
input {
  background-color: #fff;
}
.inout_uio {
  width: 502px;
  height: 40px;
  background: #fff !important;
  opacity: 1;
  border-radius: 5px 0 0 5px;
  padding: 0 15px;
  box-sizing: border-box;
  border-top: 1px solid #5178ff;
  border-left: 1px solid #5178ff;
  border-bottom: 1px solid #5178ff;
  border-right: none;
}
.button_L {
  border-radius: 0px 5px 5px 0px !important;
  background-color: #5178ff !important;
  border-color: #5178ff !important;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.input_select {
  width: 100%;
  height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.table_item_box {
  display: flex;
  align-items: flex-end;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* margin-bottom: 20px; */
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.table_item_box_l_r >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.address_model {
}
.address_item {
  width: 100%;
  height: auto;
  padding: 20px 30px;
  box-sizing: border-box;
  display: inline-block;

  border: 2px solid #e1e1e1;
  margin-bottom: 20px;
}
.user_info_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user_info {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.user_name {
  margin-right: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.title_text_gh {
  width: 100px;
  font-size: 15px;
  font-family: PingFang SC;
  color: #666666;
}
.title_details {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
.address_model >>> .el-radio__inner {
  width: 26px !important;
  height: 26px !important;
  border-width: 1px !important;
}
.address_model >>> .el-radio__label {
  width: 100% !important;
}
.el-radio {
  width: 100% !important;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
</style>


// WEBPACK FOOTER //
// src/views/salessSeturn/applyFor.vue